'use client';
import i18n from 'i18next';
import type { ReactNode } from 'react';
import { initReactI18next } from 'react-i18next';
import manageDe from '@/features/manage/languages/de';
import { de as customerDe } from '@/languages/de';

const mergedDe = {
  translation: {
    ...customerDe.translation,
    ...manageDe.translation,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      de: mergedDe,
    },
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false,
    },
  })
  .catch(console.error);

export default function IntlClientProvider({ children }: { children: ReactNode }) {
  return children;
}
